<!-- 论文上传 -->
<template>
    <div class="el-PaperUpload">
        <el-row class="page_content">
            <h1 class="head_title">论文上传</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="年级">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="专业">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="上传">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-plus" @click="seeQRCode(scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-dialog width="400px" :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
          <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "PaperUpload",
  data() {
    return {
        tableData: [],
        dialogImageUrl: '',
        dialogVisible: false
    };
  },
  created() {
   
  },
  methods: {
    seeQRCode(index){
        this.dialogVisible =true;
        this.dialogImageUrl = this.tableData[index].url;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-PaperUpload{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>


// WEBPACK FOOTER //
// src/pages/dissertation/PaperUpload.vue